import type { GameState } from './types';
import { appendEvent } from './event-log';

const BASE_MAX_HP = 30;

export interface HealOptions {
  allowOverheal?: boolean;
}

export interface HealResult {
  amountHealed: number;
  newHp: number;
}

export function applyHeal(
  state: GameState,
  playerId: string,
  amount: number,
  source: string,
  options: HealOptions = {},
): HealResult {
  const player = state.players.get(playerId);
  if (!player) throw new Error(`Player not found: ${playerId}`);

  if (player.isDead || amount <= 0) {
    return { amountHealed: 0, newHp: player.hp };
  }

  const oldHp = player.hp;
  const targetHp =
    options.allowOverheal === true ? oldHp + amount : Math.min(BASE_MAX_HP, oldHp + amount);
  const amountHealed = Math.max(0, targetHp - oldHp);

  if (amountHealed <= 0) {
    return { amountHealed: 0, newHp: oldHp };
  }

  player.hp = targetHp;
  appendEvent(state, {
    type: 'heal',
    playerId,
    amount: amountHealed,
    source,
    newHp: targetHp,
  });

  return { amountHealed, newHp: targetHp };
}
